import {Entity} from "../../state/entities/entity.model";
import {Vector3} from "three";


export interface ServerEntity {
    id: string;
    type: string,
    owner_id: string;
    components: string[];
    coord: {x:number,y:number,z:number},
    component_properties: any;
    collision_type: string
    created_at: Date;
}

export const serverEntityToEntity = (serverEntity: ServerEntity) => {
    return {
        id: serverEntity.id,
        type: serverEntity.type,
        ownerId: serverEntity.owner_id,
        components: serverEntity.components,
        coord: serverEntity.coord as Vector3,
        componentProperties: serverEntity.component_properties,
        collisionType: serverEntity.collision_type,
        creationDate: serverEntity.created_at,
    } as Entity
}